import React from 'react';

import oipIcon from '../../../images/icons/denials.png';

function LeyendaContratoIncidencia({ closeModal }) {
    return (
        <div
                                id={'LeyendaIncidencia'}
                                style={{ display: 'none' }}
                            >
                                <div className="u-1/1">
                                    <div className="u-float-left">
                                        <img src={oipIcon} style={{ height: "35px" }}></img>
                                    </div>
                                    <div>
                                        <b>Contrato con incidencias.</b> No contactar este cliente.
                                    </div>
                                </div>
                            </div>
    );
}

export default LeyendaContratoIncidencia;
